jQuery(($) => {
    'use strict';

    const $showcases = $('.project-overview');

    if ($showcases.length) {
        require.ensure([], require => {
            require([
                'in-view',
                'salvattore',
                'query-string'
            ], (inView, Salvattore, queryString) => {
                let animationDelayMultiplier = 0,
                    resetCounter,
                    $projectsCopy = $('.project-overview__item').clone(),
                    projectsGrid = document.querySelector('#projects-container'),
                    userInput;

                Salvattore.registerGrid(projectsGrid);

                // on filter input change
                $('.projects__filter__item input').on('change', function () {
                    let $el = $(this),
                        $filter = $('.projects__filter__item input:checked');

                    $el.closest('.projects__filter__item')
                        .toggleClass('is-active', $el.prop('checked'));

                    // at least one filter is active
                    if ($filter.length) {
                        // empty current project list
                        $('.projects-container').empty();

                        // add filtered projects
                        $('.projects__filter__item input:checked').map(function (i, input) {
                            $('.projects-container').append(
                                $projectsCopy.filter('.filter--' + $(input).val())
                            );
                        });
                    } else {
                        // re add all projects
                        $('.projects-container').empty();

                        $projectsCopy.each(function (i, project) {
                            $('.projects-container').append(project);
                        });
                    }

                    if (userInput !== false && history && history.pushState) {
                        let filters = $filter.toArray().map(el => el.getAttribute('id').substr(7)),
                            urlParams = queryString.parse(location.search);

                        urlParams.filter = filters && filters.length ? filters : undefined; // undefined clears the value

                        history.pushState(null, '', '?' + queryString.stringify(urlParams));
                    }

                    // show all projects and reinit salvatore
                    $('.project-overview__item').addClass('is-visible');
                    Salvattore.registerGrid(projectsGrid);
                });

                // scroll in our projects on scroll
                // NOTE: only works when the trigger wasn't changed yet
                setTimeout(function () {
                    inView('.project-overview__item')
                        .on('enter', el => {
                            if (!el.classList.contains('is-visible') && !el.classList.contains('is-fixed')) {
                                setTimeout(() => {
                                    el.classList.add('is-visible');
                                }, 150 * animationDelayMultiplier++);
                                clearTimeout(resetCounter);
                                resetCounter = setTimeout(() => { animationDelayMultiplier = 0; }, 200);
                            }
                        })
                        .check();
                }, 10);

                $(window)
                    .on('popstate', () => {
                        let urlParams = queryString.parse(location.search);

                        if ('filter' in urlParams) {

                            let filter = urlParams.filter;

                            if (typeof filter === 'string') {
                                filter = filter.replace(/(\[|])/g, '').split(',');
                            }

                            $('.projects__filter__item input').each((i, el) => {
                                let $el = $(el),
                                    oldVal = $el.prop('checked'),
                                    checked = filter.indexOf($el.attr('id').substr(7)) !== -1;

                                $el.prop('checked', checked);

                                if (checked || checked !== oldVal) {
                                    userInput = false;
                                    $el.trigger('change');
                                    userInput = true;
                                }
                            });
                        }
                    })
                    .trigger('popstate');

            });
        }, 'showcases');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/layouts/showcases.js